import type { ScheduledVrdhCall } from '@/api/types/ProviderApi'
import { HighlightText } from '@/components/HighlightText'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Link } from 'expo-router'

export const UpcomingVrdhCall = ({ vrdhCall }: { vrdhCall: ScheduledVrdhCall }) => {
	const trackRescheduleEvent = () => {
		analytics.trackEvent('reschedule-vrdh-call', {
			vrdhCallId: vrdhCall.id,
			vrdhId: vrdhCall.id,
			patientId: vrdhCall.patientId,
		})
	}

	return (
		<>
			<HighlightText>Upcoming phone call</HighlightText>
			<VStack className="items-center" gap={12}>
				<Header
					variant="h2"
					className="lg:max-w-full max-w-80 text-balance text-center leading-tight"
				>
					{vrdhCall?.startTimeFormatted}
				</Header>
				<Link
					asChild
					href={{
						pathname: '/schedule-call',
						params: {
							rescheduleCallId: vrdhCall.id,
							callReason: vrdhCall.callReason,
						},
					}}
					onPress={trackRescheduleEvent}
				>
					<Button variant={'ghost'}>
						<ButtonText spacing="wide" className="px-2 text-sm font-apercu-bold">
							RESCHEDULE
						</ButtonText>
					</Button>
				</Link>
			</VStack>
		</>
	)
}
